import React from 'react';

import CommonImage from '@/components/CommonImage';
const CreateListItem = () => {
	return (
		<>
			<div className="top-header bg-white px-4">
				<div className="filter-actions d-flex align-items-center justify-content-between">
					<div>
						<p className="semibold-14 gray_dark_01">
							Need your sample review <span className="status green-1 readius-2">12</span>
						</p>
					</div>
					<div className="d-flex justify-content-between pb-1">
						<div className="filter-actions collection-details-filter favorites-filter">
							<div className="form-group size32 m-0 search-filter filter-with-animation">
								<div className="with-icon right-icon">
									<input
										type="text"
										placeholder="Search"
										name="searchForStyle"
										autoComplete="off"
									/>
									<span className="right-icon">
										<CommonImage src="/icons/search.png" alt="search" />
									</span>
								</div>
							</div>
							<div className="option">
								<div className="dropdown">
									<button
										className="btn btn-default gap-2 dropdown-toggle d-flex align-items-center"
										type="button"
										id="menu"
										data-toggle="dropdown"
									>
										<p className="regular-14">Newest first</p>
										<img
											src="/images/chevron_down.svg"
											alt="chevron_down"
											loading="lazy"
										/>
									</button>
									<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
										<li role="presentation" className="px-4 pb-3 pt-3 active">
											<span className="font-weight-normal text-black">
												Newest first
											</span>
										</li>

										<li role="presentation" className="px-4 pb-3 pt-3">
											<span className="font-weight-normal text-black">
												Oldest first
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="add-new-design">
							<button className="button text size32 px-0">
								<span className="ml-1 text-underline gray_dark_01">SOP</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<section className="bg-white filter-data-container filter-v3-data-container py-0">
				<div className="data-table">
					<div className="favorite-collection-wrapper">
						<div className="favorite-collection-container p-0 bg-white">
							<div className="design-list-container favourite-list-container mt-3">
								<div className="design-list-row">
									<div className="single-design-card with-editable">
										<div className="card-top">
											<div className="edit-items">
												<div className="select-and-edit d-flex justify-content-between">
													<div className="custom-chekbox">
														<div className="form-group">
															<input
																type="checkbox"
																id="stage1"
																name="Company"
															/>
															<label htmlFor="stage1" />
														</div>
													</div>
													<div className="option">
														<div className="dropdown">
															<button
																className="btn btn-default dropdown-toggle"
																type="button"
																id="menu1"
																data-toggle="dropdown"
															>
																<CommonImage
																	src="/icons/more_icon.svg"
																	alt="more_icon"
																/>
															</button>
															<ul className="dropdown-menu dropdown-menu-right shadow-lg">
																<li
																	role="presentation"
																	className="px-4 pb-3 pt-3"
																>
																	<a className="font-weight-normal  text-black">
																		Edit
																	</a>
																</li>
																<li role="presentation" className="px-4 pb-3">
																	<a className="font-weight-normal  text-black">
																		Delete
																	</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</div>
											<CommonImage src="/images/t-shirt-orange.png" alt="card-image" />
										</div>
										<div className="card-content">
											<div className="card-info mb-3">
												<div className="d-flex justify-content-between">
													<a href="/collections/list?openDesign=true&productId=897053">
														<h4 className="regular-12 weight-500 gray_dark_01 pt-2 mb-0">
															BT25-A0870
														</h4>
													</a>
												</div>
												<div className="status d-flex justify-content-between pl-0 mt-2">
													<div className="d-flex flex-wrap gap-3">
														<div className="status-content d-flex flex-column gap-1">
															<span className="status custom-tooltip status-with-border yellow-1 mr-1">
																Send costing request from buyer pla...
																<span className="tooltiptext">
																	Send costing request from buyer platform
																</span>
															</span>
														</div>
													</div>
												</div>
												<ul className="common-list-component mt-1">
													<li>
														<span
															className="regular-12 gray_dark_02"
															title="POLO"
														>
															POLO
														</span>
													</li>
													<li className="text-uppercase">
														<span className="regular-12 gray_dark_02">
															Vitoria
														</span>
													</li>
													<li>
														<span>09 DEC</span>
													</li>
												</ul>
												<p class="regular-12 gray_dark_02 text-uppercase pt-1">
													Flexwear
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default CreateListItem;
